import type { AdminApiCurrentUser } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

type AdminIamResponse =
  | AdminApiCurrentUser
  | {
      data?: AdminApiCurrentUser;
    };

const normalizeCurrentUser = (payload: AdminIamResponse): AdminApiCurrentUser | null => {
  if ('role' in payload) {
    return payload;
  }
  return payload.data ?? null;
};

export default function useFetchAdminIam() {
  return useQuery({
    queryKey: ['admin', 'iam'],
    queryFn: async () => {
      const response = await fetch('/admin/api/iam');
      if (!response.ok) {
        throw new Error('管理者情報の取得に失敗しました');
      }
      const data: AdminIamResponse = await response.json();
      const currentUser = normalizeCurrentUser(data);
      if (!currentUser) {
        throw new Error('管理者情報が見つかりませんでした');
      }
      return currentUser;
    },
  });
}
